<template>
  <v-container class="upgrade-view">
    <v-row v-if="!currentMembership">
      <v-col class="text-center">
        <heart-loader />
      </v-col>
    </v-row>

    <v-row justify="center" v-if="currentMembership && !isSuccess && !isError">
      <v-col lg="6" md="8" sm="10" class="text-center">
        <h1 class="header">Upgrade Opportunity</h1>
        <p>Hi {{ firstName }}! Thank you for being with Ra since {{ joinedDate }}.</p>
        <p class="mb-8">Ra Yoga is offering new membership options for 2026 and you have the option to upgrade your current membership.</p>

        <v-row justify="center" class="table-desktop">
          <v-col lg="6" md="6" v-if="currentMembershipObject">
            <div class="upgrade-card">
              <div class="upgrade-card-title">
                <h2>Current Plan</h2>
              </div>
              <table class="upgrade-card-table">
                <tr>
                  <td>{{ currentMembershipObject.current_class_credits }} Class Credits</td>
                </tr>
                <tr>
                  <td>{{ currentMembershipObject.current_booking_window }} Booking Window</td>
                </tr>
                <tr>
                  <td>{{ currentMembershipObject.current_late_cancel }} Cancellation Window</td>
                </tr>
                <tr>
                  <td>{{ currentMembershipObject.current_rental_discount }} Rental &amp; Childcare Discount</td>
                </tr>
                <tr>
                  <td>{{ currentMembershipObject.current_retail_discount }} Retail Purchases</td>
                </tr>
                <tr>
                  <td>{{ currentMembershipObject.current_penalty_discount }} Penalty Discount</td>
                </tr>
              </table>
              <div class="upgrade-card-footer">
                <h3>Price {{ currentMembershipObject.current_price }}/mo*</h3>
                <small>Not reflective of any Special Pricing</small>
              </div>
            </div>
          </v-col>
          <v-col lg="6" md="6">
            <div class="upgrade-card">
              <div class="upgrade-card-title">
                <h2>New Plan</h2>
              </div>
              <table class="upgrade-card-table">
                <tr>
                  <td>{{ currentMembershipObject.new_class_credits }} Class Credits</td>
                </tr>
                <tr>
                  <td>{{ currentMembershipObject.new_booking_window }} Booking Window</td>
                </tr>
                <tr>
                  <td>{{ currentMembershipObject.new_late_cancel }} Cancellation Window</td>
                </tr>
                <tr>
                  <td>{{ currentMembershipObject.new_rental_discount }} Rental &amp; Childcare Discount</td>
                </tr>
                <tr>
                  <td>{{ currentMembershipObject.new_retail_discount }} Retail Purchases</td>
                </tr>
                <tr>
                  <td>{{ currentMembershipObject.new_penalty_discount }} Penalty Discount</td>
                </tr>
              </table>
              <div class="upgrade-card-footer">
                <h3>Price {{ currentMembershipObject.new_price }}/mo*</h3>
                <small>Not reflective of any Special Pricing</small>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row class="table-mobile">
          <v-col>
            <div class="upgrade-card">
              <table class="upgrade-card-table">
                <tr>
                  <td></td>
                  <td>Current Plan</td>
                  <td>New Plan</td>
                </tr>
                <tr>
                  <td class="text-left">Class Credits</td>
                  <td>{{ currentMembershipObject.current_class_credits }}</td>
                  <td>{{ currentMembershipObject.new_class_credits }}</td>
                </tr>
                <tr>
                  <td class="text-left">Booking Window</td>
                  <td>{{ currentMembershipObject.current_booking_window }}</td>
                  <td>{{ currentMembershipObject.new_booking_window }}</td>
                </tr>
                <tr>
                  <td class="text-left">Late Cancel</td>
                  <td>{{ currentMembershipObject.current_late_cancel }}</td>
                  <td>{{ currentMembershipObject.new_late_cancel }}</td>
                </tr>
                <tr>
                  <td class="text-left">Rental &amp; Childcare Discount</td>
                  <td>{{ currentMembershipObject.current_retail_discount }}</td>
                  <td>{{ currentMembershipObject.new_retail_discount }}</td>
                </tr>
                <tr>
                  <td class="text-left">Penalty Discount</td>
                  <td>{{ currentMembershipObject.current_penalty_discount }}</td>
                  <td>{{ currentMembershipObject.new_penalty_discount }}</td>
                </tr>
                <tr>
                  <td class="text-left">Price</td>
                  <td>{{ currentMembershipObject.current_price }}/mo*</td>
                  <td>{{ currentMembershipObject.new_price }}/mo*</td>
                </tr>
              </table>
            </div>
            <small class="text-right">*Not Reflective of any Legacy or Special Pricing</small>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <a @click.prevent="sendUpgradeRequest(currentMembershipObject.new_contract)">
              <img src="@/assets/request-upgrade.svg" alt="Upgrade Now" />
            </a>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <a @click="showAllUpgrades = !showAllUpgrades" target="_blank">
              See All Upgrade Options
            </a>
          </v-col>
        </v-row>

        <v-row v-if="showAllUpgrades" justify="center">
          <v-col lg="6">
            <v-row>
              <v-col><h2>BROWSE MEMBERSHIPS</h2></v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-tabs
                v-model="tab"
                centered
                round
                background-color="transparent"
                color="#3E523C">
                  <v-tab>Unlimited</v-tab>
                  <v-tab>4-Class</v-tab>
                  <v-tab>2-Class</v-tab>
                </v-tabs>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="browse-memberships">
                <v-tabs-items v-model="tab" background-color="transparent">
                  <v-tab-item background-color="transparent">
                    <v-col>
                      <v-img contain src="@/assets/unlimited-table.svg" />
                      <a href="" class="mt-8" @click.prevent="sendUpgradeRequest('Unlimited Membership 2026')">
                        <v-img contain src="@/assets/request-upgrade.svg" alt="Upgrade Now" />
                      </a>
                    </v-col>
                  </v-tab-item>
                  <v-tab-item background-color="transparent">
                    <v-col>
                      <v-img contain src="@/assets/4-classes-table.svg" />
                      <a href="" class="mt-8" @click.prevent="sendUpgradeRequest('4 Class Membership 2026')">
                        <v-img contain src="@/assets/request-upgrade.svg" alt="Upgrade Now" />
                      </a>
                    </v-col>
                  </v-tab-item>
                  <v-tab-item background-color="transparent">
                    <v-col>
                      <v-img contain src="@/assets/2-classes-table.svg" />
                      <a href="" class="mt-8" @click.prevent="sendUpgradeRequest('2 Class Membership 2026')">
                        <v-img contain src="@/assets/request-upgrade.svg" alt="Upgrade Now" />
                      </a>
                    </v-col>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <p>{{ firstName }}, you don't need to do anything if you want to keep your current membership.</p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row v-if="isSuccess" justify="center">
      <v-col lg="4" md="6" sm="10" class="text-center">
        <h2>Your request has been successfully submitted!</h2>
        <p>A member of our team will contact you shortly.</p>
        <p><small>Please note: Your upgraded contract <span style="text-decoration: underline;">will not start until you confirm with our membership team</span> related to contract start date and pricing.</small></p>
      </v-col>
    </v-row>

    <v-row v-if="isError" justify="center">
      <v-col lg="4" md="6" sm="10" class="text-center">
        <h2>Oh no! Something went wrong, please try again :(</h2>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import { DateTime } from 'luxon'
import heartLoader from '../components/heartLoader.vue';

export default {
  components: { heartLoader },
  name: 'UpgradeView',

  data() {
    return {
      tab: 0,
      currentMembership: null,
      currentMembershipObject: null,
      contractMatrix: [
        {
          "current_contract": "Essential 2 Class Membership",
          "current_class_credits": 2,
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$29",
          "new_contract": "2 Class Membership 2026",
          "new_class_credits": "2 | 0 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "5% off",
          "new_retail_discount": "5% off",
          "new_penalty_discount": "0% off",
          "new_price": "$34"
        },
        {
          "current_contract": "Essential 2 Class Membership (mgr)",
          "current_class_credits": 2,
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$29",
          "new_contract": "2 Class Membership 2026",
          "new_class_credits": "2 | 0 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "5% off",
          "new_retail_discount": "5% off",
          "new_penalty_discount": "0% off",
          "new_price": "$34"
        },
        {
          "current_contract": "Essential 2 Class Membership*",
          "current_class_credits": 2,
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$29",
          "new_contract": "2 Class Membership 2026",
          "new_class_credits": "2 | 0 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "5% off",
          "new_retail_discount": "5% off",
          "new_penalty_discount": "0% off",
          "new_price": "$34"
        },
        {
          "current_contract": "$44 - Mid Size Corp Limited Memership",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Membership - LB Opening",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Regular - 4 Class All studios",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Regular - 4 Class All studios (Jan Special)",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Regular - 4 Class All studios (MBO)",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Regular - 4 Class CM",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Regular - 4 Class CM (Jan Special)",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Regular - 4 Class CM (MBO)",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Regular - 4 Class IRV",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Regular - 4 Class LB",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Regular - 4 Class LB (Jan Special)",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Regular - 4 Class LB (MBO)",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Regular - 4 Class NB",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Regular - 4 Class NB (Jan Special)",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Regular - 4 Class NB (MBO)",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Regular Sept Only - 4 Class All studios",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Regular Sept Only - 4 Class CM",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Regular Sept Only - 4 Class LB",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Regular Sept Only - 4 Class NB",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited STM - 4 Class LB",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited STM - 4 Class NB",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Student - 4 Class All Studios",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Student - 4 Class CM",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Student - 4 Class IRV",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Student - 4 Class LB",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Student - 4 Class NB",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Student Sept Only - 4 Class All studios",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Limited Student Sept Only - 4 Class LB",
          "current_class_credits": 4,
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Plus 4 Class Membership",
          "current_class_credits": "4 | 1 Guest",
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Plus 4 Class Membership (mgr)",
          "current_class_credits": "4 | 1 Guest",
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "Plus 4 Class Membership*",
          "current_class_credits": "4 | 1 Guest",
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% off",
          "current_price": "$69",
          "new_contract": "4 Class Membership 2026",
          "new_class_credits": "4 | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "10% off",
          "new_retail_discount": "10% off",
          "new_penalty_discount": "0% off",
          "new_price": "$75"
        },
        {
          "current_contract": "$80 - Unlimited Large Corp Membership",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Custom Essential Membership",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Custom Plus Membership",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Essential Unlimited Membership",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Essential Unlimited Membership (mgr)",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Essential Unlimited Membership*",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Grand Opening NB - Both",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Large Corp - Unlimited Membership ALL",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Master Teacher Unlimited",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Plus Unlimited Membership",
          "current_class_credits": "Unlimited  | 1 Guest",
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% Off",
          "current_price": "$175",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Plus Unlimited Membership (mgr)",
          "current_class_credits": "Unlimited  | 1 Guest",
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% Off",
          "current_price": "$175",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Plus Unlimited Membership*",
          "current_class_credits": "Unlimited  | 1 Guest",
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% Off",
          "current_price": "$175",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "POYFT - Unlimited Membership",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Premium 8 Class Membership",
          "current_class_credits": "8 | 2 Guest",
          "current_booking_window": "7 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "100% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "50% Off",
          "current_price": "$159",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Premium 8 Class Membership (mgr)",
          "current_class_credits": "8 | 2 Guest",
          "current_booking_window": "7 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "100% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "50% Off",
          "current_price": "$159",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Premium 8 Class Membership*",
          "current_class_credits": "8 | 2 Guest",
          "current_booking_window": "7 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "100% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "50% Off",
          "current_price": "$159",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Premium Unlimited Membership",
          "current_class_credits": "Unlimited  | 2 Guest",
          "current_booking_window": "7 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "100% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "50% Off",
          "current_price": "$215",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Premium Unlimited Membership (mgr)",
          "current_class_credits": "Unlimited  | 2 Guest",
          "current_booking_window": "7 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "100% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "50% Off",
          "current_price": "$215",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Premium Unlimited Membership*",
          "current_class_credits": "Unlimited  | 2 Guest",
          "current_booking_window": "7 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "100% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "50% Off",
          "current_price": "$215",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Ra Yoga Custom Membership - All Studios",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Ra Yoga Custom Membership - CM",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Ra Yoga Custom Membership - NB",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Sol Membership Regular (3 Months)",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Sol Membership Regular Both",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Sol Membership S/T/M Both",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership - LB Opening",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership Reg Sept Only - CM",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership Reg Sept Only - LB",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership Reg Sept Only - NB",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership Reg Sept Only- All Studios",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership Regular - All Studios",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership Regular - All Studios (Jan Special)",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership Regular - All Studios (MBO)",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership Regular - CM",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership Regular - CM -",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership Regular - CM (Jan Special)",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership Regular - CM (MBO)",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership Regular - IRV",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership Regular - LB",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership Regular - LB (Jan Special)",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership Regular - LB (MBO)",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership Regular - NB",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership Regular - NB (Jan Special)",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership Regular - NB (MBO)",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership STM - All Studios",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership STM - All Studios (MBO)",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership STM - CM (MBO)",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership STM - IRV (MBO)",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership STM - LB",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership STM - LB (Jan Special)",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership STM - LB (MBO)",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership STM - NB",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership STM - NB (Jan Special)",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership STM - NB (MBO)",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Unlimited Membership STM Sept Only - LB",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "z_(Web Only) Unlimited Membership Regular - LB",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$135",
          "new_contract": "Unlimited Membership 2026",
          "new_class_credits": "Unlimited | 1 Guest",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$149"
        },
        {
          "current_contract": "Essential Annual Unlimited Membership",
          "current_class_credits": "Unlimited",
          "current_booking_window": "2 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "10% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "0% off",
          "current_price": "$1,377",
          "new_contract": "Unlimited Annual Membership 2026",
          "new_class_credits": "Unlimited",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$1,575"
        },
        {
          "current_contract": "Plus Annual Unlimited Membership",
          "current_class_credits": "Unlimited",
          "current_booking_window": "4 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "25% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "25% Off",
          "current_price": "$1,785",
          "new_contract": "Unlimited Annual Membership 2026",
          "new_class_credits": "Unlimited",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$1,575"
        },
        {
          "current_contract": "Premium Annual Unlimited Membership",
          "current_class_credits": "Unlimited",
          "current_booking_window": "7 Day @ 10 pm",
          "current_late_cancel": "3 Hour",
          "current_rental_discount": "100% Off",
          "current_retail_discount": "0% off",
          "current_penalty_discount": "50% Off",
          "current_price": "$2,193",
          "new_contract": "Unlimited Annual Membership 2026",
          "new_class_credits": "Unlimited",
          "new_booking_window": "7 Day @ 12 pm",
          "new_late_cancel": "8 Hour",
          "new_rental_discount": "20% Off",
          "new_retail_discount": "15% off",
          "new_penalty_discount": "10% off",
          "new_price": "$1,575"
        }
      ],
      showAllUpgrades: false,
      isSuccess: false,
      isError: false,
      error: null,
    }
  },

  computed: {
    user() {
      return this.$store.state.user
    },
    firstName() {
      return (this.user?.first_name) ? this.user.first_name : 'Ra Member'
    },
    joinedDate() {
      return DateTime.fromISO(this.user.join_datetime).toLocaleString(DateTime.DATE_FULL)
    },
  },
  methods: {
    async getActiveMemberships() {
      const memberships = await axios.get('https://rayoga.marianatek.com/api/customer/v1/me/memberships?is_active=true', {
          headers: {
            'Authorization': `Bearer ${this.$store.state.session.access_token}`
          }
        })
      console.log(memberships)

      if (memberships.data?.results) {
        this.currentMembership = memberships.data.results[0].name
      }
    },

    async sendUpgradeRequest(requestedMembership) {
      await axios.post('https://ecco-api.rayoga.com/form-submit', {
        customerId: this.user.id,
        customerName: this.user.full_name,
        customerEmail: this.user.email,
        customerPhone: this.user.phone_number,
        currentMembership:this.currentMembership,
        requestedMembership,
      })
      .then((res) => {
        // show success
        console.log(res)
        this.isSuccess = true
      })
      .catch((err) => {
        // show error
        console.log(err)
        this.isError = true
      })

      /*console.log({
        customerId: this.user.id,
        customerName: this.user.full_name,
        customerEmail: this.user.email,
        customerPhone: this.user.phone_number,
        currentMembership:this.currentMembership,
        requestedMembership,
      })*/
    },
  },
  async beforeMount() {

    if (this.$store.state.session.access_token === undefined) {
      this.$store.commit('setGoToUpgrade', true)

      this.$router.push({ name: 'SignupView' })
    } else {
      this.$store.commit('setGoToUpgrade', false)
    }
    await this.getActiveMemberships()
    this.currentMembershipObject = this.contractMatrix.find(o => o.current_contract === this.currentMembership)
  }
}
</script>

<style lang="scss">
.upgrade-view {
  .header {
    text-transform: uppercase;
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 24px;
  }

  .upgrade-card {
    border-radius: 8px;
    text-align: center;
    overflow: hidden;

    .upgrade-card-title {
      margin-bottom: 0px;
      padding: 6px 0;
      background-color: #789577;
      color: #ffffff;
    }

    .upgrade-card-table {
      width: 100%;
      margin-bottom: 0px;
      border-spacing: 0;

      tr:nth-of-type(odd) {
        background-color: #ffffff;
      }

      tr:nth-of-type(even) {
        background-color: #EDEBE8;
      }

      td {
        padding: 12px 15px;
        font-size: 0.8rem;
      }
    }

    .upgrade-card-footer {
      background-color: #3E523C;
      padding: 12px 0;
      color: #ffffff;

      h3 {
        margin: 0;
        line-height: 1;
      }

      small {
        font-size: 0.6rem;
        line-height: 1;
      }
    }
  }

  .table-mobile {
    .upgrade-card {
      .upgrade-card-table {
        td {
          font-size: 0.7rem;
        }

        td:nth-of-type(2),
        td:nth-of-type(3) {
          border-left: 1px solid #000;
        }

        tr:first-of-type td {
          border-left: 1px solid #789577;
          color: #fff;
          background-color: #789577;
          text-transform: uppercase;
          font-weight: bold;
        }

        tr:last-of-type td {
          border-left: 1px solid #3E523C;
          color: #fff;
          background-color: #3E523C;
          font-weight: bold;
          font-size: 1rem;
        }
      }
    }
  }

  .theme--light.v-tabs-items {
    background-color: transparent;
  }

  .browse-memberships a {
    display: block;
  }
}

@media (min-width: 769px) {
  .upgrade-view {
    .table-desktop {
      display: flex;
    }
    .table-mobile {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  .upgrade-view {
    .table-desktop {
      display: none;
    }
    .table-mobile {
      display: flex;
    }
  }
}
</style>
